import logApi from '../api/LogApi';
import * as commonActions from './commonActions';

export const logActions = {
    getLogs: (request) => (dispatch) => {
        dispatch({
            type: commonActions.LOADING,
            value: true
        });
        return logApi
            .getLogs(request)
            .then(data => {
                dispatch({
                    type: commonActions.LOADING,
                    value: false
                });
                return data;
            });
    }
};